const testIds = {
  regionItem: 'region-item',
  prefectureListItem: 'prefecture-list-item',
};

export default testIds;
